module.exports = __webpack_public_path__ + "static/media/nav-icon-value-active.3997adfa.svg";